import React from 'react';
import { AwardIcon, CheckIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { checkoutUrl, included, price, priceBefore, productShortName, totalBonuses, totalVolumes } from '../data/offer';
export function PricingSection() {
  return <section id="pricing" className="scroll-mt-4 bg-amber-50 py-16 sm:py-24" aria-labelledby="pricing-title" data-id="element-176" data-mp="1j9gzgtubtlbh">
      <div className="mx-auto max-w-3xl px-4" data-id="element-177" data-mp="1nbbzzw4fnuo7">
        <h2 id="pricing-title" className="text-center text-3xl font-extrabold text-green-950 sm:text-4xl" data-id="element-178" data-mp="1ncmzvkurcia1">
          Choose your option
        </h2>

        <article className="mt-10 overflow-hidden rounded-2xl border-2 border-green-900 bg-white shadow-xl shadow-stone-700/10" data-id="element-179" data-mp="1x8ginlz2l809">
          <div className="flex items-center justify-between gap-4 bg-green-900 px-6 py-4 sm:px-10" data-id="element-180" data-mp="227b4yxw8xep4">
            <span className="inline-flex items-center gap-2 rounded-full bg-amber-500 px-3 py-1.5 text-[11px] font-extrabold uppercase tracking-[.14em] text-green-950" data-id="element-181" data-mp="2wjp9nh2hs2k">
              <AwardIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-182" data-mp="1mhq1qds25mif" /> Main offer
            </span>
            <span className="text-xs font-bold uppercase tracking-[.14em] text-amber-400" data-id="element-183" data-mp="1howwzpwlae6c">66% off today</span>
          </div>
          <div className="p-6 sm:p-10" data-id="element-184" data-mp="1crep82ub64zx">
            <div className="flex flex-col gap-6 border-b border-stone-100 pb-7 sm:flex-row sm:items-end sm:justify-between" data-id="element-185" data-mp="17s20fcjvmnup">
              <div data-id="element-186" data-mp="25fsmggdkoxaf">
                <h3 className="text-2xl font-extrabold leading-tight text-green-950" data-id="element-187" data-mp="25e7nmek86s6r">{productShortName}</h3>
                <p className="mt-2 text-sm text-stone-600" data-id="element-188" data-mp="20gz9cp2778as">
                  All {totalVolumes} volumes + {totalBonuses} exclusive bonuses ready to use in your classroom.
                </p>
              </div>
              <div className="shrink-0 sm:text-right" data-id="element-189" data-mp="1rhu8hc35z2vg">
                <span className="text-sm text-stone-600" data-id="element-190" data-mp="k2g0gmvok4ln">
                  Regular price <span className="line-through" data-id="element-191" data-mp="g0uhcjsjyu30">{priceBefore}</span>
                </span>
                <p className="mt-1 whitespace-nowrap text-5xl font-extrabold text-green-900" data-id="element-192" data-mp="hhrtmzpwf1o7">{price}</p>
                <p className="text-xs font-bold uppercase tracking-[.14em] text-stone-500" data-id="element-193" data-mp="mgur9z3ju5m5">Today · 66% discount</p>
              </div>
            </div>

            <ul className="mt-7 grid gap-2.5 sm:grid-cols-2" data-id="element-194" data-mp="7j2al3m9nb6d">
              {included.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-snug text-stone-900" data-id="element-195" data-mp="ch3tnojozahu">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-green-700" aria-hidden="true" data-id="element-196" data-mp="3uvd0w5951t7v" />
                  {item}
                </li>)}
            </ul>

            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-9 w-full" data-id="element-197" data-mp="3kzt6xoe4x4lr">
              Get my teacher ready now
            </Button>

            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-stone-600" data-id="element-198" data-mp="3bxa8rhlang5u">
              <span className="inline-flex items-center gap-1.5" data-id="element-199" data-mp="3fyc8s0n1bw8v">
                <LockIcon className="h-4 w-4 text-green-700" aria-hidden="true" data-id="element-200" data-mp="2xatkz4bfi292" /> Secure payment
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-201" data-mp="2scs50s9auj1t">
                <ZapIcon className="h-4 w-4 text-green-700" aria-hidden="true" data-id="element-202" data-mp="36brsvxozmtwx" /> Instant access
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-203" data-mp="31cycnxibgot2">
                <ShieldCheckIcon className="h-4 w-4 text-green-700" aria-hidden="true" data-id="element-204" data-mp="31et29p4j953h" /> 7-day guarantee
              </span>
            </div>
            <p className="mt-4 text-center text-xs text-stone-600" data-id="element-205" data-mp="3bbe2zy9iru1i">
              You pay in USD. Your payment platform automatically shows the conversion to your local currency.
            </p>
          </div>
        </article>
      </div>
    </section>;
}